// extracted by mini-css-extract-plugin
export default {"container":"components-BorderedRow-styles-module__container--fO5Cp","stacked":"components-BorderedRow-styles-module__stacked--REmov"};